import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import QuoteCollection from "@/pages/home/components/QuoteCollection";
import HealingLines from "@/pages/home/components/HealingLines";
import TimeReflections from "@/pages/home/components/TimeReflections";
import SceneCompanions from "@/pages/home/components/SceneCompanions";
import MomentCaptions from "@/pages/home/components/MomentCaptions";
import ResonanceWall from "@/pages/home/components/ResonanceWall";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <QuoteCollection />
        <HealingLines />
        <TimeReflections />
        <SceneCompanions />
        <MomentCaptions />
        <ResonanceWall />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}